/*!

=========================================================
* Black Dashboard PRO React - v1.2.4
=========================================================

* Product Page: https://www.creative-tim.com/product/black-dashboard-pro-react
* Copyright 2024 Creative Tim (https://www.creative-tim.com)

* Coded by Creative Tim

=========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.

*/
import React, { Suspense, lazy } from "react";
import ReactDOM from "react-dom/client";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";

// i18n'i import et
import './i18n';


import AuthLayout from "layouts/Auth/Auth.js";
import AdminLayout from "layouts/Admin/Admin.js";
import CustomerDetailQR from "views/customers/CustomerDetailQR";
import SecureMediaViewer from "views/media/SecureMediaViewer";

import "assets/css/nucleo-icons.css";
import "react-notification-alert/dist/animate.css";
import "assets/css/theme-colors.css";
import "assets/scss/black-dashboard-pro-react.scss?v=1.2.1";
import "assets/demo/demo.css";

const LandingScreen = lazy(() => import("views/landing/LandingScreen"));

const root = ReactDOM.createRoot(document.getElementById("root"));

const queryClient = new QueryClient();
const LandingFallback = () => (
  <div
    style={{
      minHeight: "100vh",
      background: "#0b1220",
      color: "rgba(255,255,255,0.7)",
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      fontFamily: "system-ui, sans-serif",
    }}
  >
    Loading…
  </div>
);

const RootRoute = () => {
  const token = localStorage.getItem("token");
  if (token) {
    return <Navigate to="/dashboard" replace />;
  }
  return (
    <Suspense fallback={<LandingFallback />}>
      <LandingScreen />
    </Suspense>
  );
};

root.render(
  <QueryClientProvider client={queryClient}>
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<RootRoute />} />
        <Route
          path="/landing"
          element={
            <Suspense fallback={<LandingFallback />}>
              <LandingScreen />
            </Suspense>
          }
        />
        <Route path="/customer/detail/:id" element={<CustomerDetailQR activeColor="blue" />} />
        <Route path="/media/share/:token" element={<SecureMediaViewer />} />
        <Route path="/login" element={<AuthLayout />} />
        <Route path="/register" element={<AuthLayout />} />
        <Route path="/*" element={<AdminLayout />} />
      </Routes>
    </BrowserRouter>
  </QueryClientProvider>
);
